import React, { Component, Fragment } from 'react';
import { notification, Upload, Button } from 'antd';
import XLSX from 'xlsx';
import { make_cols } from './MakeColumns';

import { UploadOutlined, DownloadOutlined } from '@ant-design/icons';

class ExcelReader extends Component {
  state = {
    data: [],
    cols: []
  };

  handleUpload(file) {
    if (file === null) {
      notification.error({placement: 'bottomLeft', message: `엑셀 파일을 올려주세요`, duration: 2});
      return;
    }
    
    if (this.props.onExcelUploadIng !== undefined) {
      this.props.onExcelUploadIng(true);
    } else {
      console.log("ExcelReader-----start ");
    }
    /* Boilerplate to set up FileReader */
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA : true });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws);
      /* Update state */
      this.setState({ data: data, cols: make_cols(ws['!ref']) }, () => {
        // console.log('uploadList', this.state.data);
        // console.log(JSON.stringify(this.state.data, null, 2));
        if (this.props.excelUpload !== undefined) {
          // console.log('uploadList', this.state.data);
          if (this.state.data.length > 0) {
            this.props.excelUpload(this.state.data);
          } else {
            if (this.props.onExcelUploadIng !== undefined) {
              this.props.onExcelUploadIng(false);
            } else {
              console.log("ExcelReader-----end ");
            }
            notification.error({placement: 'bottomLeft', message: `업로드할 데이터가 없습니다.`, duration: 2});
          }
        } else {
          if (this.props.onExcelUploadIng !== undefined) {
            this.props.onExcelUploadIng(false);
          } else {
            console.log("ExcelReader-----end ");
          }
        }
      });
    };

    if (rABS) {
      reader.readAsBinaryString(file);
    } else {
      reader.readAsArrayBuffer(file);
    };
  }

  render() {
    const { actionType, pageUrl, schInfo, actionText } = this.props;
    const SheetJSFT = [
      "xlsx", "xlsb", "xlsm", "xls", "xml", "csv", "txt", "ods", "fods", "uos", "sylk", "dif", "dbf", "prn", "qpw", "123", "wb*", "wq*", "html", "htm"
    ].map(function(x) { return "." + x; }).join(",");
    
    return (
      actionType === "upload"
      ?
        <div>
          <Upload 
            accept={SheetJSFT}
            beforeUpload={(file)=>{
              this.handleUpload(file);
              return false;
            }}
            fileList={null}
            // onChange={(file)=>console.log("onChange", file)}
          >
            <Button>
              <UploadOutlined />
              {actionText !== undefined && actionText !== null && 
              <Fragment>{actionText}</Fragment>}
              엑셀업로드
            </Button>
          </Upload>
        </div>
      :
        <Fragment>
          {pageUrl === 'DOWN-CENTER-LIST' && 
            (<a
                href={process.env.REACT_APP_URL+`/file/${pageUrl}/`
                + `?templet=${actionType === "templet" ? true : false}`
                + `&ceCd=${encodeURIComponent(schInfo.ceCd)}`
                + `&ceNm=${encodeURIComponent(schInfo.ceNm)}`
                + `&ceUseYn=${encodeURIComponent(schInfo.ceUseYn)}`
                + `&ceBranchCd=${encodeURIComponent(schInfo.ceBranchCd)}`}
            ><Button><DownloadOutlined /> {actionType === "templet" 
            ? <Fragment>탬플릿다운로드</Fragment> : <Fragment>엑셀다운로드</Fragment>}
            </Button></a>)}
          {pageUrl === 'DOWN-USER-LIST' &&
            (<a
                href={process.env.REACT_APP_URL+`/file/${pageUrl}/`
                + `?templet=${actionType === "templet" ? true : false}`
                + `&userId=${encodeURIComponent(schInfo.userId)}`
                + `&userNm=${encodeURIComponent(schInfo.userNm)}`
                + `&userJobCd=${encodeURIComponent(schInfo.userJobCd)}`
                + `&userUseYn=${encodeURIComponent(schInfo.userUseYn)}`
                + `&userCeCd=${encodeURIComponent(schInfo.ceCd)}`
                + `&ceBranchCd=${encodeURIComponent(schInfo.ceBranchCd)}`}
            ><Button><DownloadOutlined />{actionType === "templet" 
            ? <Fragment>탬플릿다운로드</Fragment> : <Fragment>엑셀다운로드</Fragment>}
            </Button></a>)}
          {pageUrl === 'DOWN-ORDER-LIST' &&
            (<a
                href={process.env.REACT_APP_URL+`/file/${pageUrl}/`
                + `?orStat=${encodeURIComponent(schInfo.orStat)}`
                + `&strDate=${encodeURIComponent(schInfo.strDate)}`
                + `&endDate=${encodeURIComponent(schInfo.endDate)}`
                + `&ceCd=${encodeURIComponent(schInfo.ceCd)}`
                + `&ceBranchCd=${encodeURIComponent(schInfo.ceBranchCd)}`}
            ><Button><DownloadOutlined /> 엑셀다운로드</Button></a>)}
          {pageUrl === 'DOWN-ORDER-DETAIL' &&
            (<a
                href={process.env.REACT_APP_URL+`/file/${pageUrl}/`
                + `?orStat=${encodeURIComponent(schInfo.orStat)}`
                + `&strDate=${encodeURIComponent(schInfo.strDate)}`
                + `&endDate=${encodeURIComponent(schInfo.endDate)}`
                + `&orUserId=${encodeURIComponent(schInfo.orUserId)}`
                + `&orUserNm=${encodeURIComponent(schInfo.orUserNm)}`
                + `&ceCd=${encodeURIComponent(schInfo.ceCd)}`
                + `&ceBranchCd=${encodeURIComponent(schInfo.ceBranchCd)}`
                + `&orCartNo=${encodeURIComponent(schInfo.orCartNo)}`}
            ><Button><DownloadOutlined /> 엑셀다운로드</Button></a>)}
          {pageUrl === 'DOWN-DELIVERY-LIST' &&
            (<a
                href={process.env.REACT_APP_URL+`/file/${pageUrl}/`
                + `?strDate=${encodeURIComponent(schInfo.strDate)}`
                + `&endDate=${encodeURIComponent(schInfo.endDate)}`}
            ><Button><DownloadOutlined /> 납품내역 다운로드</Button></a>)}
          {pageUrl === 'DOWN-READY-LIST' &&
            (<a
                href={process.env.REACT_APP_URL+`/file/${pageUrl}/`
                + `?strDate=${encodeURIComponent(schInfo.strDate)}`
                + `&endDate=${encodeURIComponent(schInfo.endDate)}`}
            ><Button><DownloadOutlined /> 세부내역 다운로드</Button></a>)}
          {pageUrl === 'DOWN-SETTLE-LIST' &&
            (<a
                href={process.env.REACT_APP_URL+`/file/${pageUrl}/`
                + `?strDate=${encodeURIComponent(schInfo.strDate)}`
                + `&endDate=${encodeURIComponent(schInfo.endDate)}`
                + `&orGdNm=${encodeURIComponent(schInfo.orGdNm)}`
                + `&ceCd=${encodeURIComponent(schInfo.ceCd)}`
                + `&ceBranchCd=${encodeURIComponent(schInfo.ceBranchCd)}`}
            ><Button><DownloadOutlined /> 엑셀다운로드</Button></a>)}
          {pageUrl === 'DOWN-RETURN-LIST' &&
            (<a
                href={process.env.REACT_APP_URL+`/file/${pageUrl}/`
                + `?orStat=${encodeURIComponent(schInfo.orStat)}`
                + `&strDate=${encodeURIComponent(schInfo.strDate)}`
                + `&endDate=${encodeURIComponent(schInfo.endDate)}`
                + `&orUserId=${encodeURIComponent(schInfo.orUserId)}`
                + `&orUserNm=${encodeURIComponent(schInfo.orUserNm)}`
                + `&ceCd=${encodeURIComponent(schInfo.ceCd)}`
                + `&ceBranchCd=${encodeURIComponent(schInfo.ceBranchCd)}`
                + `&orCartNo=${encodeURIComponent(schInfo.orCartNo)}`
                + `&orGdNm=${encodeURIComponent(schInfo.orGdNm)}`}
            ><Button><DownloadOutlined /> 엑셀다운로드</Button></a>)}
            {pageUrl === 'DOWN-STATS-GOODS' &&
            (<a
                href={process.env.REACT_APP_URL+`/file/${pageUrl}/`
                + `?statsType=${encodeURIComponent(schInfo.statsType)}`
                + `&orBranchCd=${encodeURIComponent(schInfo.orBranchCd)}`
                + `&date=${encodeURIComponent(schInfo.date)}`
                + `&date2=${encodeURIComponent(schInfo.date2)}`
                + `&strDate=${encodeURIComponent(schInfo.strDate)}`
                + `&endDate=${encodeURIComponent(schInfo.endDate)}`
                + `&strDate2=${encodeURIComponent(schInfo.strDate2)}`
                + `&endDate2=${encodeURIComponent(schInfo.endDate2)}`}
            ><Button><DownloadOutlined /> 엑셀다운로드</Button></a>)}
            {pageUrl === 'DOWN-STOCK-LIST' &&
            (<a
                href={process.env.REACT_APP_URL+`/file/${pageUrl}/`
                + `?strDate=${encodeURIComponent(schInfo.strDate)}`
                + `&endDate=${encodeURIComponent(schInfo.endDate)}`}
            ><Button><DownloadOutlined /> 엑셀다운로드</Button></a>)}
        </Fragment>
    )
  }
}

export default ExcelReader;